var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"absolute":"","indeterminate":""}}):_vm._e(),(_vm.crumbs)?_c('m-crumbs'):_vm._e(),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }